module.exports = __webpack_public_path__ + "img/sorvete.613b9168.svg";